import EntityProfileCaregiverRelationshipsSection from "../../../../entityProfileModal/sections/caregiverRelationships/EntityProfileCaregiverRelationshipsSection";
import { getRelatedEntityId } from "../../../../entityProfileModal/sections/caregiverRelationships/caregiverRelationships.utils";
import type { CaregiverId, PatientId } from "../../../../../shared/schema/schema";
import { getFullName } from "../../../../../shared/utils/get-full-name";
import type { PatientProfileBridgeActions } from "../../../patientProfileModal.actions";
import { PatientProfilePatient } from "../../../patientProfileModal.types";

type Props = {
  actions: PatientProfileBridgeActions;
  patient?: PatientProfilePatient;
  patientId: PatientId;
};

export default function PatientProfileCaregiverRelationshipsSection(props: Props) {
  return (
    <EntityProfileCaregiverRelationshipsSection
      owner={{
        type: "Patient",
        id: props.patientId,
        option: {
          id: Number(props.patientId),
          displayId: props.patient?.displayId ?? null,
          displayName: props.patient === undefined ? "" : getFullName(props.patient),
        },
      }}
      onOpenRelatedEntity={(relationship) =>
        props.actions.navigateToCaregiver(
          getRelatedEntityId(relationship, "caregiver") as CaregiverId
        )
      }
    />
  );
}
